import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@mui/material";
import { MediationKindEnum } from "common/enums/MediationKindEnum";
import { DialogHeader } from "components/Parts/Atoms/DialogHeader";
import React from "react";
import styles from "./MediationKindSelectDialog.module.scss";
import { useMediationKindSelectDialogHooks } from "./hooks";
import { MediationKindSelectDialogProps } from "./interfaces";

export const MediationKindSelectDialog = React.memo(
  (props: MediationKindSelectDialogProps) => {
    const { mediationKinds, busy, onModeClick, onOkClick } =
      useMediationKindSelectDialogHooks(props);

    return (
      <>
        <Dialog
          style={props.style}
          className={`${props.className} ${styles.dialog}}`}
          open={props.open}
          onClose={props.onClose}
          aria-labelledby="estate-types-select-title"
          aria-describedby="estate-types-select-description"
          fullWidth
          slotProps={{
            paper: { className: styles.dialogPaper },
            backdrop: { className: styles.backdrop }
          }}
        >
          <DialogHeader
            id="estate-types-select-title"
            icon={<PanToolAltIcon />}
          />
          <DialogContent id="estate-types-select-description">
            <Box className={styles.paragraph}>
              <Box
                className={`${styles.button} ${
                  mediationKinds.includes(MediationKindEnum.一般)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(MediationKindEnum.一般)}
              >
                {MediationKindEnum.一般}
              </Box>
              <Box
                className={`${styles.button} ${
                  mediationKinds.includes(MediationKindEnum.専任)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(MediationKindEnum.専任)}
              >
                {MediationKindEnum.専任}
              </Box>
              <Box
                className={`${styles.button} ${
                  mediationKinds.includes(MediationKindEnum.売主)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(MediationKindEnum.売主)}
              >
                {MediationKindEnum.売主}
              </Box>
              <Box
                className={`${styles.button} ${
                  mediationKinds.includes(MediationKindEnum.仲介)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(MediationKindEnum.仲介)}
              >
                {MediationKindEnum.仲介}
              </Box>
              <Box
                className={`${styles.button} ${
                  mediationKinds.includes(MediationKindEnum.代理)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(MediationKindEnum.代理)}
              >
                {MediationKindEnum.代理}
              </Box>
              <Box
                className={`${styles.button} ${
                  mediationKinds.includes(MediationKindEnum.専属)
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onModeClick(MediationKindEnum.専属)}
              >
                {MediationKindEnum.専属}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions className={styles.actions}>
            <Button
              variant="contained"
              className={styles.cancelButton}
              disabled={busy}
              onClick={props.onCloseClick}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              className={styles.okButton}
              disabled={busy || mediationKinds.length === 0}
              onClick={onOkClick}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);
